export const vi = {
  "name": "Vietnamese",
  "flagCode": "vn",
  "locale": "vi-VN",
  "project": {
    "name": "Driver Signup"
  },
  "key": "vi",
  "validations": {
    "PLEASE_SELECT_CITY": "Please select city.",
    "PLEASE_SELECT_SERVICE": "Please select service.",
    "PLEASE_SELECT_DRIVER_TYPE": "Please select driver type.",
    "PLEASE_INPUT_FIRSTNAME": "Please enter your first name.",
    "PLEASE_INPUT_LASTNAME": "Please enter your last name.",
    "PLEASE_INPUT_EMAIL": "Please enter your email.",
    "INVALID_EMAIL": "Vui lòng sử dụng email hợp lệ để đăng ký.",
    "PLEASE_INPUT_MOBILE_PHONE": "Please enter your phone number.",
    "INVALID_PHONE_NUMBER": "Please specify a valid phone number.",
    "PHONE_NUNBER_EXITS": "Số điện thoại này đã được sử dụng với một tài khoản khác.",
    "USERNAME_EXITS": "This username already exists on our system.",
    "ERROR_INPUT_VALID_USERNAME": "Username may only contain lower letters & numbers and must be between 3 and 20 characters long",
    "FIELD_IS_REQUIRED": "*Thông tin bắt buộc.",
    "REFERRAL_CODE_INVALID": "Referral code is invalid.",
    "EMAIL_EXITS": "Email này đã tồn tại. Vui lòng nhập email khác.",
    "INVALID_USERNAME": "Please specify a valid username.",
    "FIELD_IS_REQUIRED_BETWEEN_3_TO_20": "Username must be between 3 and 20 characters.",
    "PHONE_NUNBER_EXITS_IN_GROUP": ""
  },
  "errors": {
    "3034": "This phone has been existing on the system. Please input another one.",
    "4001": "The License Plate is exits",
    "NETWORK_ERROR": "Error: Network Error"
  },
  "general": {
    "CONTINUE": "Continue",
    "STEP_COMPLETE": "{0}/{1} Complete",
    "STEP_HEADER": "Step {0}",
    "BACK": "Back",
    "NEXT": "Next",
    "SUBMIT": "Submit",
    "Clear_Selected_Items": "Clear selected items",
    "no_results": "No results",
    "add_new_item": "Add New"
  },
  "home": {
    "BECOME": "Become a %{name} Driver.",
    "HEADING": "Enter your basic information to get started",
    "APPLY_NOW": "Đăng ký",
    "INDIVIDUAL_CAR_GOJO": "Transport/Taxi - I own vehicle",
    "INDIVIDUAL_CAR": "Xe cá nhân - Chở khách",
    "COMPANY_CAR": "Xe công ty - Chở khách",
    "DELIVERY_INDIVIDUAL_CAR": "Xe cá nhân - Chở hàng",
    "DELIVERY_COMPANY_CAR": "Xe cá nhân - Chở hàng",
    "PLACEHOVER_SELECT_PRE_CITY": "Thành phố",
    "PLACEHOVER_SELECT_REGISTRATION_TYPE": "Chọn loại tài xế",
    "USERNAME": "Username",
    "FIRST_NAME": "Tên",
    "LAST_NAME": "Họ",
    "EMAIL": "Địa chỉ email (không bắt buộc)",
    "PHONE_NUMBER": "Điện thoại di động",
    "REFERRAL_CODE": "Mã giới thiệu (không bắt buộc)",
    "I_AGREE_TO": "Khi tiếp tục, tôi đồng ý %{name} được phép thu thập, sử dụng và tiết lộ thông tin được tôi cung cấp theo",
    "TERMS_OF_USE": "Điều khoản Dịch vụ",
    "AND": "và",
    "PRIVACY_POLICY": "Chính sách Quyền riêng tư",
    "I_AGREE_TO_AFTER": "sử dụng mà tôi đã đọc và hiểu."
  },
  "finish": {
    "FINISH_1": "Cảm ơn bạn đã đăng ký trở thành tài xế của %{name}!",
    "FINISH_3": "Đăng nhập và hoàn tất hồ sơ của bạn để kích hoạt tài khoản.",
    "FINISH_USE_PASSWORD_1": "Cảm ơn bạn đã đăng ký trở thành đối tác của %{name}!",
    "FINISH_USE_PASSWORD_2": "Để kích hoạt tài khoản của bạn & nhận chuyến, vui lòng:",
    "FINISH_USE_PASSWORD_3": "1. Đăng nhập với số điện thoại đã đăng ký",
    "FINISH_USE_PASSWORD_4": "2. Mật khẩu: <span style='font-weight: bold'>12345678</span>",
    "FINISH_USE_PASSWORD_5": "3. Hoàn tất hồ sơ trên ứng dụng",
    "OK": "Đăng nhập",
    "downloadApp": "Tải ứng dụng tài xế <span style='color: %{color}' >%{name}</span> ngay và đăng nhập với số điện thoại bạn đã đăng ký."
  },
  "datePlaceHolder": "MM/DD/YYYY"
};